import React, { useContext, useEffect } from 'react';
import tw from 'twin.macro';
import { AppContext } from '../context';
import { VideoPlayer } from './VideoPlayer';
import { EmbedMedia } from '../embed';
export const ItemDetailsMedia = ({
  item,
  counter,
  index,
  related,
  setSlidesActive,
  children,
  videoEndedAction,
  openImageExternal,
  isStickyVideoMobile,
  ...restProps
}) => {
  // TODO (MINOR):save json responces as fixtures for unit tests to cover all these cases
  /* EXAMPLES MULTIPLE MEDIA ITEMS
      MULTIPLE IMAGES: http://localhost:8080/item/7683953_0af3f9f4
      MULTIPLE VIDEOS: (check stills?)
        http://localhost:8080/item/7677657_d42ed649
        http://localhost:8080/item/7685297_1d746e4f
      MULTIPLE MIXED ITEMS:
        http://localhost:8080/item/7682385_d35af77f
      YOUTUBE:
        http://localhost:8080/item/7690059_64c58a33
      TWITTER:
        http://localhost:8080/item/7254093_5872e637
        http://localhost:8080/item/7677875_5f7732bb
      AUDIO:
        http://localhost:8080/item/2149551_1d05cfc7
      IMAGE NOT SHOWING : http://localhost:8080/item/6957017_4eaa8126
      VERSION NOT PROVIDED : http://localhost:8080/item/7675795_1f7bc9df
    */
  const { slideIn, setTwitchLiveStream } = useContext(AppContext);
  const { mediatype, variants } = item.media[index];
  const [{ version, uri }] = variants;
  const isVideo = mediatype === 'VIDEO';
  const isAudio = mediatype === 'AUDIO';
  const isImage = mediatype === 'FOTO';
  const [type, id] = uri.split(':');
  const isEmbed = isVideo && version === 'embed';
  const useEmbedHeight =
    isEmbed && (type === 'instagram' || type === 'tiktok' || type === 'twitter');

  useEffect(() => {
    setTwitchLiveStream(type === 'twitch' && id === 'dumpert');
  }, [item]);

  return (
    <div
      css={[
        isStickyVideoMobile && !counter && !useEmbedHeight && tw`sticky top-14 z-30`,
        isStickyVideoMobile && !counter && !useEmbedHeight && slideIn.active && tw`!top-0`,
      ]}
      {...restProps}
    >
      <div
        css={[
          tw`bg-black relative`,
          useEmbedHeight &&
            tw`h-[fit-content] 
          m-auto
          flex 
          justify-center
          items-center
          min-h-[300px] 
          md:min-h-[400px] 
          xl:min-h-[460px] 
          2xl:min-h-[600px]
        `,
        ]}
      >
        <div css={[tw`h-full w-full`, !useEmbedHeight && tw`aspect-w-16 aspect-h-9`]}>
          {isEmbed && <EmbedMedia uri={uri} />}
          {isVideo && !isEmbed && (
            <VideoPlayer
              item={item}
              related={related}
              mediaIndex={index}
              videoEndedAction={videoEndedAction}
            />
          )}
          {isImage && (
            <div tw='flex justify-center items-center'>
              {counter && (
                <div tw='absolute bg-brand rounded-full w-7 h-7 left-2 top-2 flex justify-center items-center text-dark font-bold'>
                  <small tw='leading-6'>{`${index ? index + 1 : 1}`}</small>
                </div>
              )}
              <div tw='h-full cursor-pointer' onClick={setSlidesActive || undefined}>
                <img tw='object-contain h-full mx-auto' src={uri} alt={item.title} />
              </div>
            </div>
          )}
          {isAudio && (
            <div tw='flex justify-center items-center'>
              <audio controls autoPlay tw='w-2/3'>
                <source src={uri} type='audio/mpeg' />
                Your browser does not support the audio element.
              </audio>
            </div>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};
